import React from 'react';
type SectionHeadingProps = {
  eyebrow?: string;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  align?: 'center' | 'left';
  tone?: 'dark' | 'light';
};
export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  align = 'center',
  tone = 'dark'
}: SectionHeadingProps) {
  const isDark = tone === 'dark';
  return <header className={`${align === 'center' ? 'text-center' : 'text-left'} mx-auto max-w-2xl`} data-id="element-44" data-mp="3k0p0bbt9q8g7">
      {eyebrow ? <p className="mb-3 text-[11px] font-bold uppercase tracking-[0.2em] text-gold" data-id="element-45" data-mp="bmpulighv8pi">
          {eyebrow}
        </p> : null}
      <h2 className={`font-display text-[26px] font-bold leading-[1.15] sm:text-4xl ${isDark ? 'text-cream' : 'text-ink'}`} data-id="element-46" data-mp="1v3jrn82jbna">
        {title}
      </h2>
      {subtitle ? <p className={`mt-3 text-[15px] leading-relaxed sm:text-base ${isDark ? 'text-cream/65' : 'text-ink/65'}`} data-id="element-47" data-mp="uizjz1wujlot">
          {subtitle}
        </p> : null}
    </header>;
}